export function vibrate(ms: number) {
  if (navigator.vibrate) {
    navigator.vibrate([ms]);
  }
}
